import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { GetDevBoxAddOnResponse, getDevBoxAddOn } from '../../../data/services/data-plane-api/add-ons';
import { ClientError, FailureOperation, isFailureResponse } from '../../../models/common';
import {
    getDevBoxAddOn as getDevBoxAddOnActionCreator,
    getDevBoxAddOnError,
    getDevBoxAddOnFailed,
    getDevBoxAddOnSuccess,
} from '../../actions/add-ons/add-ons-action-creators';
import { GetDevBoxAddOnAction } from '../../actions/add-ons/add-ons-actions';
import { getAccessToken } from '../../actions/identity/identity-action-creators';
import { GetAccessTokenForDevCenterDataPlanePayload } from '../../actions/identity/identity-actions';
import { createSagaError } from '../../effects/create-saga-error';
import { putAndAwait } from '../../effects/put-and-await';
import { resolveAction } from '../../effects/resolve-action';
import { takeEvery } from '../../effects/take';

export function* getDevBoxAddOnSaga(action: GetDevBoxAddOnAction): SagaIterator {
    const { meta, payload } = action;
    const { activityId } = meta ?? {};
    const { id, name } = payload;

    try {
        const accessToken: string = yield putAndAwait(
            getAccessToken(GetAccessTokenForDevCenterDataPlanePayload(), meta)
        );

        const response: GetDevBoxAddOnResponse = yield call(getDevBoxAddOn, id, name, accessToken, activityId);

        if (isFailureResponse(response)) {
            yield put(getDevBoxAddOnFailed({ failure: response, id }, meta));
            yield resolveAction(action, response);
            return;
        }

        yield put(getDevBoxAddOnSuccess({ id, result: response.data }, meta));
        yield resolveAction(action, response);
    } catch (err) {
        const error: ClientError = yield createSagaError(err, FailureOperation.GetDevBoxAddOn);
        yield put(getDevBoxAddOnError({ error, id }, meta));
    }
}

export function* getDevBoxAddOnListenerSaga(): SagaIterator {
    yield takeEvery(getDevBoxAddOnActionCreator, getDevBoxAddOnSaga);
}
